import "./App.css";
import styled from "styled-components";
import { Navbar } from "./components/navbar";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from "./components/home";
import Footer from "./components/footer";
import 'bootstrap/dist/css/bootstrap.min.css';
import Breathe from "./components/pages/breathe";
import Sleep from "./components/pages/sleep";
import Meditate from "./components/pages/meditate";
import FAQ from "./components/pages/FAQ";

const AppContainer = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  top:0px;
  bottom: 0px;
  position: absolute;
`;

// const InnerContainer = styled.div`
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding: 2em;
// `;

// const SomeContent = styled.h2`
//   color: #fff;
// `;


function App() {
  return (
    <Router>
      <AppContainer>
        <Navbar />
        <div className="content">
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/breathe">
              <Breathe />
            </Route>
            <Route path="/meditate">
              <Meditate />
            </Route>
            <Route path="/FAQ">
              <FAQ />
            </Route>
            <Route path="/sleep">
              <Sleep />
            </Route>
          </Switch>
        </div>
        <Footer/>
      </AppContainer>
    </Router>
  );
}

export default App;
